import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "diem_den_an_toan";
let startDate = "2020-11-08T17:00:00.000Z";

moduleApi.getDiemDenAnToanAll = () => {
    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_to_now_group_by_province",
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToanToday = (params) => {

    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_by_day_group_by_province",
        value: {
            from: params.from,
            to: params.to,
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToan7day = (params) => {

    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_by_day_group_by_province",
        value: {
            from: params.from,
            to: params.to,
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToan30day = (params) => {

    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_by_day_group_by_province",
        value: {
            from: params.from,
            to: params.to,
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToanByTypeAll = () => {

    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_to_now_group_by_type",
    };
    return ApiService(api);
};


moduleApi.getDiemDenAnToanByTypeToday = (params) => {

    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_to_now_group_by_type",
        value: {
            from: params.from,
            to: params.to,
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToanByType7day = (params) => {

    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_to_now_group_by_type",
        value: {
            from: params.from,
            to: params.to,
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToanByType30day = (params) => {

    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_to_now_group_by_type",
        value: {
            from: params.from,
            to: params.to,
        }
    };
    return ApiService(api);
};


moduleApi.getDiemDenAnToanCount = (params) => {
    let api = {
        module: 'dashboard',
        type: "views",
        viewAction: "ddat_count",
        value: {
            to: params.to
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToanDaKhaiBao = (params) => {
    let api = {
        module: 'dashboard',
        type: "views",
        viewAction: "ddat_count_daily_declared",
        value: {
            to: params.to
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToanDaily = (params) => {
    let api = {
        module: 'dashboard',
        type: "views",
        viewAction: "ddat_statistic_daily",
        value: {
            to: params.to
        }
    };
    return ApiService(api);
};

moduleApi.getDiemDenAnToanByTypeByTime = (params) => {
    let api = {
        module: moduleName,
        type: "views",
        viewAction: "total_ddat_by_day_group_by_type",
        value: {
            from: startDate,
            to: params.to,
        }
    };
    return ApiService(api);
};

moduleApi.getTotalDeclaredCountProvince = (params) => {
    let api = {
        module: 'dashboard',
        type: "views",
        viewAction: "ddat_total_declared_province_count",
        value: params
    };
    return ApiService(api);
};

moduleApi.getStatsTotalDeclaredprovince = (params) => {
    let api = {
        module: 'dashboard',
        type: "views",
        viewAction: "stats_total_declared_provinces",
        value: params
    };
    return ApiService(api);
};

export default moduleApi;